







import {Component, Prop, Vue} from 'vue-property-decorator';

@Component
export default class RenderPrice extends Vue {
  @Prop() private value!: number;

  public getValue(): string {
    return this.formatPriceWithThousandSeparators(Math.round(this.value));
  }

  private formatPriceWithThousandSeparators(x: number): string {
    return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  }
}
